const BUCKET_CATEGORIES = ['one', 'three', 'five'];
// Replaces any one/three/five category with the given bucket, keeping every other category.
export function mergeBucketCategory(existing, bucket) {
    const others = (existing !== null && existing !== void 0 ? existing : []).filter((c) => !BUCKET_CATEGORIES.includes(c));
    return bucket === undefined ? others : [...others, bucket];
}
